/* eslint-disable no-empty-pattern */
import roundHistoryQuestionService from '@/services/roundHistoryQuestion.js';

export default {
	debug: false,
	namespaced: true,
	state: {
		roundHistoryQuestionLists: [],
		roundHistoryQuestionList: {},
		roundHistoryQuestions: [],
		searchParams: {
			customerId: '',
			done: null,
			orderBy: '',
			pageSize: 10,
			currentPage: 1
		},
		searchParamsQ: {
			done: null,
			orderBy: '',
			pageSize: 10,
			currentPage: 1
		},
		totalCount: 0,
		totalPages: 0,
		totalCountQ: 0,
		totalPagesQ: 0
	},

	mutations: {
		SET_HISTORYQUESTIONLISTS(state, roundHistoryQuestionLists) {
			state.roundHistoryQuestionLists = roundHistoryQuestionLists;
		},
		SET_HISTORYQUESTIONLIST(state, roundHistoryQuestionList) {
			state.roundHistoryQuestionList = roundHistoryQuestionList;
		},
		SET_HISTORYQUESTIONS(state, roundHistoryQuestions) {
			state.roundHistoryQuestions = roundHistoryQuestions;
		},
		SET_PAGESIZE(state, pageSize) {
			state.searchParams.pageSize = pageSize;
		},
		SET_CURRENTPAGE(state, currentPage) {
			state.searchParams.currentPage = currentPage;
		},
		SET_TOTALPAGES(state, totalPages) {
			state.totalPages = totalPages;
		},
		SET_TOTALCOUNT(state, totalCount) {
			state.totalCount = totalCount;
		},
		SET_PAGESIZEQ(state, pageSize) {
			state.searchParamsQ.pageSize = pageSize;
		},
		SET_CURRENTPAGEQ(state, currentPage) {
			state.searchParamsQ.currentPage = currentPage;
		},
		SET_TOTALPAGESQ(state, totalPages) {
			state.totalPagesQ = totalPages;
		},
		SET_TOTALCOUNTQ(state, totalCount) {
			state.totalCountQ = totalCount;
		}
	},

	actions: {
		async getRoundHistoryQuestionList(
			{ commit, dispatch },
			roundHistoryQuestionListId
		) {
			dispatch('appStore/setLoading', 1, { root: true });

			return await roundHistoryQuestionService
				.getRoundHistoryQuestionList(roundHistoryQuestionListId)
				.then(data => {
					commit('SET_HISTORYQUESTIONLIST', data);
					dispatch('appStore/setLoading', -1, { root: true });
				})
				.catch(err => {
					console.log('Error getting roundHistoryQuestionList: ', err);
					dispatch('appStore/setLoading', -1, { root: true });
				});
		},
		async getRoundHistoryQuestionLists({ state, commit, dispatch }) {
			return await roundHistoryQuestionService
				.getRoundHistoryQuestionLists(state.searchParams)
				.then(data => {
					const paginationValues = data._pagination;

					if (state.searchParams.currentPage <= paginationValues.totalPages || paginationValues.totalPages == 0) {
						commit('SET_HISTORYQUESTIONLISTS', data);
						commit('SET_CURRENTPAGE', paginationValues.currentPage);
						commit('SET_TOTALCOUNT', paginationValues.totalCount);
						commit('SET_TOTALPAGES', paginationValues.totalPages);
					} else {
						commit('SET_CURRENTPAGE', paginationValues.totalPages);
						dispatch('getRoundHistoryQuestionLists');
					}
				})
				.catch(err => {
					console.log('Error getting roundHistoryQuestionLists: ', err);
				});
		},
		async createRoundHistoryQuestionList(
			{ dispatch },
			roundHistoryQuestionList
		) {
			return await roundHistoryQuestionService
				.createRoundHistoryQuestionList(roundHistoryQuestionList)
				.then(() => {
					dispatch('getRoundHistoryQuestionLists');
				})
				.catch(err => {
					console.log('Error creating roundHistoryQuestionList: ', err);
				});
		},
		async updateRoundHistoryQuestionList(
			{ dispatch },
			roundHistoryQuestionList
		) {
			return await roundHistoryQuestionService
				.updateRoundHistoryQuestionList(roundHistoryQuestionList)
				.then(() => {
					dispatch('getRoundHistoryQuestionLists');
				})
				.catch(err => {
					console.log('Error updating roundHistoryQuestionList: ', err);
				});
		},
		async deleteRoundHistoryQuestionList(
			{ dispatch },
			roundHistoryQuestionList
		) {
			return await roundHistoryQuestionService
				.deleteRoundHistoryQuestionList(roundHistoryQuestionList.id)
				.then(() => {
					dispatch('getRoundHistoryQuestionLists');
				})
				.catch(err => {
					console.log('Error deleting roundHistoryQuestionList: ', err);
				});
		},

		async updateRoundHistoryQuestion({}, roundHistoryQuestion) {
			return await roundHistoryQuestionService
				.updateRoundHistoryQuestion(roundHistoryQuestion)
				.catch(err => {
					console.log('Error updating roundHistoryQuestion: ', err);
					throw err;
				});
		},


		async getRoundHistoryQuestions({ state, commit, dispatch, rootGetters },params) {
			dispatch('appStore/setLoading', 1, { root: true });

			if (!rootGetters['user/hasFull']) {
				state.searchParamsQ.customerId = rootGetters['user/getUser'].customer.id;
			} else {
				state.searchParamsQ.customerId = rootGetters['user/getActiveCustomer']?.id;
			}

			state.searchParamsQ.buildingId = rootGetters['buildingStore/selectedBuilding'].id;
			state.searchParamsQ.userBuildingId = rootGetters['buildingStore/getUserBuildingId'];

			return await roundHistoryQuestionService
				.getRoundHistoryQuestions({ ...state.searchParamsQ, ...params })
				.then(data => {
					const paginationValues = data._pagination;

					if (state.searchParams.currentPage <= paginationValues.totalPages || paginationValues.totalPages == 0) {
						commit('SET_HISTORYQUESTIONS', data);
						commit('SET_CURRENTPAGEQ', paginationValues.currentPage);
						commit('SET_TOTALCOUNTQ', paginationValues.totalCount);
						commit('SET_TOTALPAGESQ', paginationValues.totalPages);
					} else {
						commit('SET_CURRENTPAGEQ', paginationValues.totalPages);
						dispatch('getRoundHistoryQuestions');
					}

					dispatch('appStore/setLoading', -1, { root: true });
				})
				.catch(err => {
					console.log('Error getting roundHistoryQuestionLists: ', err);
					dispatch('appStore/setLoading', -1, { root: true });
				});
		},

		setRoundHistoryQuestionList({ commit }, roundHistoryQuestionList) {
			commit('SET_HISTORYQUESTIONLIST', roundHistoryQuestionList);
		},
		setRoundHistoryQuestionLists({ commit }, roundHistoryQuestionLists) {
			commit('SET_HISTORYQUESTIONLISTS', roundHistoryQuestionLists);
		},
		setCurrentPage({ commit }, currentPage) {
			commit('SET_CURRENTPAGE', currentPage);
		},
		setPageSize({ commit }, pageSize) {
			commit('SET_PAGESIZE', pageSize);
		},
		setTotalPages({ commit }, totalPages) {
			commit('SET_TOTALPAGES', totalPages);
		},
		setTotalCount({ commit }, totalCount) {
			commit('SET_TOTALCOUNT', totalCount);
		},
		setCurrentPageQ({ commit }, currentPage) {
			commit('SET_CURRENTPAGEQ', currentPage);
		},
		setPageSizeQ({ commit }, pageSize) {
			commit('SET_PAGESIZEQ', pageSize);
		},
		setTotalPagesQ({ commit }, totalPages) {
			commit('SET_TOTALPAGESQ', totalPages);
		},
		setTotalCountQ({ commit }, totalCount) {
			commit('SET_TOTALCOUNTQ', totalCount);
		}
	},

	getters: {
		totalPages: state => {
			return state.totalPages;
		},
		totalCount: state => {
			return state.totalCount;
		},
		currentPage: state => {
			return state.searchParams.currentPage;
		},
		pageSize: state => {
			return state.searchParams.pageSize;
		},
		roundHistoryQuestionList: state => {
			return state.roundHistoryQuestionList;
		},
		roundHistoryQuestionLists: state => {
			return state.roundHistoryQuestionLists;
		},
		roundHistoryQuestions: state => {
			return state.roundHistoryQuestions;
		},
		pagination: state => {
			return {
				currentPage: state.searchParams.currentPage,
				pageSize: state.searchParams.pageSize,
				totalPages: state.totalPages,
				totalCount: state.totalCount
			};
		},
		paginationQ: state => {
			return {
				currentPage: state.searchParamsQ.currentPage,
				pageSize: state.searchParamsQ.pageSize,
				totalPages: state.totalPagesQ,
				totalCount: state.totalCountQ
			};
		}
	}
};
